import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL =
    "dstore-service/v1/api/cms/dstore/product/activation/key/";

export default {
    getActivationKeys: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "list/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateActivationKey: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "update",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteActivationKey: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "delete",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getImportsStatus(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "import/status",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    importActivationKeys(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "import", param, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
